import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, CloseBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import { storeCategoriesMng } from '../api/storeCategoriesMng';
import StoreCategoryForm from './StoreCategoryForm';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

function AddStoreCategoryDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { open, onClose, onAdd = () => {} } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState();

  const createStoreCategory = async () => {
    setLoading(true);
    const storeCategory = { ...formData };
    delete storeCategory.isValid;
    try {
      await storeCategoriesMng.addStoreCategory(storeCategory);
      onAdd();
      _onClose();
      toast.success('Store category added successfully', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const _onClose = () => {
    setFormData({});
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        Add Store Category
        <CloseBtn
          onClick={() => {
            onClose();
          }}
        />
      </DialogTitle>
      <DialogContent>
        <StoreCategoryForm
          onChange={(data) => {
            console.log('on change');
            console.log(data);
            setFormData({ ...data });
          }}
          values={formData}
        />
        <div
          style={{
            marginBottom: '20px',
            marginTop: '10px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || !formData || !formData.isValid}
            label={<span>Add Store Category</span>}
            onClick={createStoreCategory}
            onEnter={createStoreCategory}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

AddStoreCategoryDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
};

AddStoreCategoryDialog.defaultProps = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: () => {},
};

export default AddStoreCategoryDialog;
